import { useCallback, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Comment, Meta } from 'utils/types';

import c from '../utils/constants';
import { commentsTransformers } from '../transformers';

interface Result {
  data: Comment[];
  meta: Meta;
}

export default function useGetComments() {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  const [id, setId] = useState<string | null>(null);
  const [params, setParams] = useState({});

  const getComments = useCallback((noteId: string | null, noteParams = {}) => {
    setId(noteId);
    setParams(noteParams);
  }, []);

  const query = useQuery<Comment[], Error>({
    queryKey: [c.NOTES, id, c.NOTE_COMMENT],
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: `api/v1/comments/${id}/children`,
            params,
            transformer: commentsTransformers.comments,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/comments/${id}/children`,
            params,
            transformer: commentsTransformers.comments,
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id,
  });

  return { getComments, query };
}
